import React from 'react'

const Simplecard = () => {
  return (
    <div className='w-full flex justify-between items-center px-4 py-4 border border-gray-200  '>
     <h1 className='text-sm font-semibold text-jet'>Check delivery time & services </h1>
     <button className='border text-xs font-bold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500 px-4 py-2 rounded-sm'>ENTER PIN CODE</button>
    </div>
  )
}

export default Simplecard